import { ActionTypes } from 'constants/index';

const initialState = {
  loading: false,
  sessionStart: null,
  sessionEnd: null,
  pageSession: null,
  userActivityRecordEvent: null,
  error: {}
};

const userActivity = function (state = initialState, action) {
  const s = state != null ? state : initialState;
  const act = action != null ? action : {};
  switch (act.type) {
    case ActionTypes.USER_ACTIVITY_SESSION_START: {
      return { ...s, loading: true };
    }
    case ActionTypes.USER_ACTIVITY_SESSION_START_SUCCESS: {
      return { ...s, loading: false, sessionStart: act.payload, error: {} };
    }
    case ActionTypes.USER_ACTIVITY_SESSION_START_FAILURE: {
      return { ...s, loading: false, error: { ...(s.error || {}), sessionStart: act.payload?.error } };
    }
    case ActionTypes.USER_ACTIVITY_SESSION_END: {
      return { ...s, loading: true };
    }
    case ActionTypes.USER_ACTIVITY_SESSION_END_SUCCESS: {
      return { ...s, loading: false, sessionEnd: act.payload, error: {} };
    }
    case ActionTypes.USER_ACTIVITY_SESSION_END_FAILURE: {
      return { ...s, loading: false, error: { ...(s.error || {}), sessionEnd: act.payload?.error } };
    }
    case ActionTypes.USER_ACTIVITY_PAGE_SESSION_START: {
      return { ...s, loading: true };
    }
    case ActionTypes.USER_ACTIVITY_PAGE_SESSION_START_SUCCESS: {
      return { ...s, loading: false, pageSession: act.payload, error: {} };
    }
    case ActionTypes.USER_ACTIVITY_PAGE_SESSION_START_FAILURE: {
      return { ...s, loading: false, error: { ...(s.error || {}), pageSessionStart: act.payload?.error } };
    }
    case ActionTypes.USER_ACTIVITY_RECORD_EVENT: {
      return { ...s, loading: true };
    }
    case ActionTypes.USER_ACTIVITY_RECORD_EVENT_SUCCESS: {
      return { ...s, loading: false, userActivityRecordEvent: act.payload, error: {} };
    }
    case ActionTypes.USER_ACTIVITY_RECORD_EVENT_FAILURE: {
      return { ...s, loading: false, error: { ...(s.error || {}), userActivityRecordEvent: act.payload?.error } };
    }
    default: {
      return s;
    }
  }
};

export default userActivity;
